import { render } from "./DemoLeadFormContent.vue?vue&type=template&id=744899ad"
import script from "./DemoLeadFormContent.vue?vue&type=script&lang=js"
export * from "./DemoLeadFormContent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/AxumWebPage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__